
import Vue from 'vue'
import RIcon from '@/components/icons/index.vue'
import RTooltip from './RTooltip.vue'

export default Vue.extend({
  name: 'TaxInfo',
  components: {
    RTooltip,
    RIcon,
  },
  props: {
    total: {
      type: [String, Number],
    },
    // a different variant:
    // - bubble's a bit to the left;
    // - is generally smaller;
    // - has perHour bit
    wizard: {
      type: Boolean,
    },
  },
  computed: {
    getPosition(): string {
      return this.wizard ? 'top-middle' : 'top-left'
    },
    getDimensions(): number {
      return this.wizard ? 16 : 17
    },
    getViewBox(): number {
      return this.wizard ? 17 : 16
    },
  },
})
